<div class="mf-menu-footer">
    <div class="text-center">
        <img src="assets/svg/network_znak-white.svg" alt="" style="width: 32px" />
        <small><mds-app-info [classList]="'mf-version'" [separator]="''"></mds-app-info></small>
    </div>
</div>
